import React, { useState } from "react";
import EmbeddedYouTubeVideo from "./VideoEmbed";
import retrotv from "../src/grabbag-pictures/retroTV.png";
import FilmArchiveTV from "./FilmArchiveTV";

// List of video IDs to cycle through
const videoIds = [
  "tCKzVUNx5R4",
  "UBIdUPpRSg4",
  "bXNwMF5JndM",
  "NifaRg_a_pg",
  "mcAIWpJ-ISc",
  "3yl4ygURdFo",
  "Tm-oPeoWaIQ",
  "dQw4w9WgXcQ",
];

const RetroTV = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const handleNext = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === videoIds.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? videoIds.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="retroTvPage">
      <div className="tvContainer">
        <div className="videoPageHeaderContainer">
          <h1 className="videoPageHeader">
            FilmSlobs <span style={{ color: "white" }}>Video Archives</span>
          </h1>
        </div>

        {/* Mobile-only buttons */}
        <div className="button-row-mobile">
          <button className="rewindButton" onClick={handlePrevious}>
            ⏪
          </button>
          <button className="fastForwardButton" onClick={handleNext}>
            ⏩
          </button>
        </div>

        {/* Desktop layout with side buttons */}
        <div className="tv-controls">
          {/* Rewind button */}
          <button className="rewindButton" onClick={handlePrevious}>
            ⏪
          </button>

          {/* TV */}
          <div className="tv-container">
            <img
              src={retrotv}
              alt="Vintage TV with VHS player"
              className="tv-image"
            />
            <div className="tv-video-frame">
              <FilmArchiveTV videoId={videoIds[currentVideoIndex]} />
            </div>
          </div>

          {/* Fast forward button */}
          <button className="fastForwardButton" onClick={handleNext}>
            ⏩
          </button>
        </div>
      </div>
    </div>
  );
};

export default RetroTV;
